import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  checkAccess,
  CommonErrorMsg,
  confirmDelete,
  ErrorMsg,
  GetFormData,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../Util/common";
import { corefetch, ImageURL } from "../../Util/axios_core_helper";
import { toast } from "react-toastify";

const FacilityForm = ({
  facilityDetails,
  setFacilityDetails,
  goNext,
  handleChange,
}) => {
  const [FacilityForm, setFacilityForm] = useState({
    FacilityID: 0,
    FacilityName: "",
    Height: 0,
    FloorArea: "",
    StandardRate: 0,
    MinimumRate: 0,
    BaseCapacity: 0,
    MaxCapacity: 0,
    SimpleView: "",
    DetailedView: "",
    Latitude: 0,
    Longitude: 0,
    Image: "",
    OldImagePath: "",
    SortOrder: 0,
    SavedBy: 0,
    Description: "",
  });

  const [refreshflag, setrefreshflag] = useState(0);
  const [editVisible, setEditVisible] = useState(false);

  const [error, setError] = useState({});
  const modalRef = useRef(null);
  const [FacilityList, setFacilityList] = useState([]);
  const [QDup, setQDup] = useState(false);

  useEffect(() => {
    if (facilityDetails != null && facilityDetails.FacilityForm != null) {
      setFacilityForm(facilityDetails.FacilityForm);
    }
  }, [facilityDetails]);

  const clearForm = () => {
    setFacilityForm({
      FacilityID: 0,
      FacilityName: "",
      Height: 0,
      FloorArea: "",
      StandardRate: 0,
      MinimumRate: 0,
      BaseCapacity: 0,
      MaxCapacity: 0,
      SimpleView: "",
      DetailedView: "",
      Latitude: 0,
      Longitude: 0,
      // Image: "",
      OldImagePath: "",
      SortOrder: 0,
      SavedBy: 0,
      Description: "",
    });
    setError({});
    setEditVisible(false);
    const form = document.getElementById("form-culture-config");
    if (form) {
      form.reset();
    }
  };
  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const hasAvifFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (hasAvifFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (!file) {
      // No file selected
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
        ValidFile: false,
      }));
      setFacilityForm((prev) => ({
        ...prev,
        Image: "",
      }));
      onValidation("Image", e.target.value);
      return;
    }

    if (file && file.type.startsWith("image/")) {
      // Valid image file
      setError({ ...error, ValidFile: false });

      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        InValidFileSize: isFileTooLarge,
      }));

      if (isFileTooLarge) {
        // File is too large, clear the Image field
        setFacilityForm((prev) => ({
          ...prev,
          Image: file,
        }));
      } else {
        let temp = FacilityForm;
        temp.Image = file;

        const reader = new FileReader();
        reader.onloadend = () => {
          setFacilityForm((prev) => ({
            ...prev,
            previewUrl: reader.result,
          }));
        };
        reader.readAsDataURL(file);

        setFacilityForm(temp);
        document.getElementById("image-name").value = file.name;
      }

      onValidation("Image", e.target.value);
    } else {
      // Invalid file type
      e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        InValidFileSize: false,
      }));
      setFacilityForm((prev) => ({
        ...prev,
        Image: "",
      }));
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;
    let oversize = false;
    oversize = FacilityForm.Image?.size > maxSizeInBytes;

    const urlPattern =
      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
    let SimpleViewInvalid = false;
    if (!urlPattern.test(FacilityForm.SimpleView?.trim())) {
      SimpleViewInvalid = true;
    }
    let DetailedViewInValid = false;
    if (!urlPattern.test(FacilityForm.DetailedView?.trim())) {
      DetailedViewInValid = true;
    }
    const err = ValidateForm(e);
    if (err) {
      setError(err);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: oversize,
        SimpleViewValid: SimpleViewInvalid,
        DetailedViewValid: DetailedViewInValid,
      }));
    } else if (
      !oversize &&
      !SimpleViewInvalid &&
      !DetailedViewInValid &&
      !QDup
    ) {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
        SimpleViewValid: false,
        DetailedViewValid: false,
      }));
      setFacilityDetails((prev) => ({
        ...prev,
        FacilityForm: FacilityForm,
      }));

      goNext();
    } else {
      if (oversize) {
        setError((prevError) => ({
          ...prevError,
          InValidFileSize: true,
        }));
      }
      if (SimpleViewInvalid) {
        setError((prevError) => ({
          ...prevError,
          SimpleViewValid: true,
        }));
      }
      if (DetailedViewInValid) {
        setError((prevError) => ({
          ...prevError,
          DetailedViewValid: true,
        }));
      }
    }
  };
  const onValidationURL = (name, val) => {
    try {
      new URL(val.trim());
      setError((prevErr) => ({
        ...prevErr,
        [name]: false,
      }));
    } catch (error) {
      setError((prevErr) => ({
        ...prevErr,
        [name]: true,
      }));
    }
  };
  const fetchData = async () => {
    try {
      const list = await corefetch("Facility/GetFacilityDetails");
      setFacilityList(list);
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <form onSubmit={onSubmit}>
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Venue Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              maxLength={100}
              className="form-control field"
              name="FacilityName"
              value={FacilityForm.FacilityName || ""}
              placeholder="Venue Name"
              data-required="true"
              onChange={(e) => {
                setFacilityForm((prev) => ({
                  ...prev,
                  FacilityName: e.target.value,
                }));
                onValidation("FacilityName", e.target.value);
                let dup;
                if (FacilityForm.FacilityID > 0) {
                  const matchingItem = FacilityList.find(
                    (item) =>
                      item.facilityName.trim().toLowerCase() ==
                        e.target.value.trim().toLowerCase() &&
                      item.facilityID != FacilityForm.FacilityID
                  );

                  dup = matchingItem;
                  setQDup(dup);
                } else {
                  const matchingItem = FacilityList.find(
                    (item) =>
                      item.facilityName.trim().toLowerCase() ==
                      e.target.value.trim().toLowerCase()
                  );
                  dup = matchingItem;
                  setQDup(dup);
                }
              }}
            />
            <CommonErrorMsg
              text="Venue Name is required"
              IsError={error.FacilityName}
            />
            {QDup && <ErrorMsg text="Venue Name already exist" />}
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Description <span className="text-danger">*</span>
            </label>
            <textarea
              type="text"
              maxLength={1000}
              className="form-control field"
              name="Description"
              value={FacilityForm.Description || ""}
              placeholder="Description"
              data-required="true"
              onChange={(e) => {
                setFacilityForm((prev) => ({
                  ...prev,
                  Description: e.target.value,
                }));
                onValidation("Description", e.target.value);
              }}
            />
            <CommonErrorMsg
              text="Description is required"
              IsError={error.Description}
            />
            {/* {error.Description && <ErrorMsg text="Description is required" />} */}
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Height <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              maxLength={100}
              min={0}
              className="form-control field"
              name="Height"
              value={FacilityForm.Height || ""}
              placeholder="Height"
              data-required="true"
              onKeyDown={(e) => {
                if (e.key === "-" || e.key === "e") {
                  e.preventDefault(); // Prevent typing `-` or `e`
                }
              }}
              onChange={(e) => {
                setFacilityForm((prev) => ({
                  ...prev,
                  Height: e.target.value,
                }));
                onValidation("Height", e.target.value);
              }}
            />
            <CommonErrorMsg text="Height is required" IsError={error.Height} />
            {/* {error.Height && <ErrorMsg text="Height is required" />} */}
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Floor Area <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              maxLength={200}
              className="form-control field"
              name="FloorArea"
              value={FacilityForm.FloorArea}
              placeholder="Floor Area"
              data-required="true"
              onChange={(e) => {
                setFacilityForm((prev) => ({
                  ...prev,
                  FloorArea: e.target.value,
                }));
                onValidation("FloorArea", e.target.value);
              }}
            />
            <CommonErrorMsg
              text="Floor Area is required"
              IsError={error.FloorArea}
            />
            {/* {error.FloorArea && <ErrorMsg text="FloorArea is required" />} */}
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Standard Rate <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              maxLength={200}
              min={0}
              className="form-control field"
              name="StandardRate"
              value={FacilityForm.StandardRate || ""}
              placeholder="Standard Rate"
              data-required="true"
              onKeyDown={(e) => {
                if (e.key === "-" || e.key === "e") {
                  e.preventDefault(); // Prevent typing `-` or `e`
                }
              }}
              onChange={(e) => {
                setFacilityForm((prev) => ({
                  ...prev,
                  StandardRate: e.target.value,
                }));
                onValidation("StandardRate", e.target.value);
              }}
            />
            <CommonErrorMsg
              text="Standard Rate is required"
              IsError={error.StandardRate}
            />
            {/* {error.StandardRate && <ErrorMsg text="StandardRate is required" />} */}
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Minimum Rate <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              maxLength={200}
              min={0}
              className="form-control field"
              name="MinimumRate"
              value={FacilityForm.MinimumRate || ""}
              placeholder="Minimum Rate"
              data-required="true"
              onKeyDown={(e) => {
                if (e.key === "-" || e.key === "e") {
                  e.preventDefault(); // Prevent typing `-` or `e`
                }
              }}
              onChange={(e) => {
                setFacilityForm((prev) => ({
                  ...prev,
                  MinimumRate: e.target.value,
                }));
                onValidation("MinimumRate", e.target.value);
              }}
            />
            <CommonErrorMsg
              text="Minimum Rate is required"
              IsError={error.MinimumRate}
            />
            {/* {error.MinimumRate && <ErrorMsg text="MinimumRate is required" />} */}
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Base Capacity<span className="text-danger">*</span>
            </label>
            <input
              type="number"
              maxLength={200}
              min={0}
              className="form-control field"
              name="BaseCapacity"
              value={FacilityForm.BaseCapacity || ""}
              placeholder="Base Capacity"
              data-required="true"
              onKeyDown={(e) => {
                if (e.key === "-" || e.key === "e") {
                  e.preventDefault(); // Prevent typing `-` or `e`
                }
              }}
              onChange={(e) => {
                setFacilityForm((prev) => ({
                  ...prev,
                  BaseCapacity: e.target.value,
                }));
                onValidation("BaseCapacity", e.target.value);
              }}
            />
            <CommonErrorMsg
              text="Base Capacity is required"
              IsError={error.BaseCapacity}
            />
            {/* {error.BaseCapacity && <ErrorMsg text="BaseCapacity is required" />} */}
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Max Capacity<span className="text-danger">*</span>
            </label>
            <input
              type="number"
              maxLength={200}
              min={0}
              className="form-control field"
              name="MaxCapacity"
              value={FacilityForm.MaxCapacity || ""}
              placeholder="Max Capacity"
              data-required="true"
              onKeyDown={(e) => {
                if (e.key === "-" || e.key === "e") {
                  e.preventDefault(); // Prevent typing `-` or `e`
                }
              }}
              onChange={(e) => {
                setFacilityForm((prev) => ({
                  ...prev,
                  MaxCapacity: e.target.value,
                }));
                onValidation("MaxCapacity", e.target.value);
              }}
            />
            <CommonErrorMsg
              text="Max Capacity is required"
              IsError={error.MaxCapacity}
            />
            {/* {error.MaxCapacity && <ErrorMsg text="MaxCapacity is required" />} */}
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">
              360 Simple View<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              maxLength={200}
              className="form-control field"
              name="SimpleView"
              value={FacilityForm.SimpleView}
              placeholder="360 kuula links"
              data-required="true"
              onChange={(e) => {
                setFacilityForm((prev) => ({
                  ...prev,
                  SimpleView: e.target.value,
                }));
                onValidation("SimpleView", e.target.value);
                onValidationURL("SimpleViewValid", e.target.value);
              }}
            />
            <CommonErrorMsg
              text={
                error.SimpleView
                  ? "Simple View is required"
                  : error.SimpleViewValid
                  ? "Please enter a valid URL"
                  : ""
              }
              IsError={error.SimpleView || error.SimpleViewValid}
            />
            {/* <CommonErrorMsg
              text={
                error.SimpleView
                  ? "Simple View is required"
                  : "Please enter a valid URL for SimpleView"
              }
              IsError={error.SimpleView || error.SimpleViewValid}
            /> */}
            {/* {error.SimpleView && <ErrorMsg text="SimpleView is required" />} */}
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">
              360 Detailed View<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              maxLength={200}
              className="form-control field"
              name="DetailedView"
              value={FacilityForm.DetailedView}
              placeholder="360 kuula links"
              data-required="true"
              onChange={(e) => {
                setFacilityForm((prev) => ({
                  ...prev,
                  DetailedView: e.target.value,
                }));
                onValidation("DetailedView", e.target.value);
                onValidationURL("DetailedViewValid", e.target.value);
              }}
            />

            <CommonErrorMsg
              text={
                error.DetailedView
                  ? "Detailed View is required"
                  : error.DetailedViewValid
                  ? "Please enter a valid URL"
                  : ""
              }
              IsError={error.DetailedView || error.DetailedViewValid}
            />
            {/* {error.DetailedView && <ErrorMsg text="DetailedView is required" />} */}
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Latitude<span className="text-danger">*</span>
            </label>
            <input
              type="number"
              step="any" // Allows decimal values
              maxLength={200}
              min={-90} // Latitude range: -90 to 90
              max={90}
              className="form-control field"
              name="Latitude"
              value={FacilityForm.Latitude || ""}
              placeholder="Latitude"
              data-required="true"
              onChange={(e) => {
                const value = e.target.value;

                // Allow only numbers and decimal points
                if (/^-?\d*\.?\d*$/.test(value)) {
                  setFacilityForm((prev) => ({
                    ...prev,
                    Latitude: value,
                  }));
                }

                // Optionally validate the latitude range
                if (value >= -90 && value <= 90) {
                  onValidation("Latitude", value);
                }
              }}
            />
            <CommonErrorMsg
              text="Latitude is required"
              IsError={error.Latitude}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">
              Longitude<span className="text-danger">*</span>
            </label>
            <input
              type="number"
              step="any" // Allows decimal values
              maxLength={200}
              min={-180} // Longitude range: -180 to 180
              max={180}
              className="form-control field"
              name="Longitude"
              value={FacilityForm.Longitude || ""}
              placeholder="Longitude"
              data-required="true"
              onChange={(e) => {
                const value = e.target.value;

                if (/^-?\d*\.?\d*$/.test(value)) {
                  setFacilityForm((prev) => ({
                    ...prev,
                    Longitude: value,
                  }));
                }

                // Optionally validate the longitude range
                if (value >= -180 && value <= 180) {
                  onValidation("Longitude", value);
                }
              }}
            />
            <CommonErrorMsg
              text="Longitude is required"
              IsError={error.Longitude}
            />
            {/* {error.Longitude && <ErrorMsg text="Longitude is required" />} */}
          </div>
          <div className="col-md-4 mb-3">
            <div className="input-block mb-3">
              <label className="form-label">
                Cover Image <span className="text-danger">*</span>
                <InfoIcon content="Kindly upload an Image within 500KB size." />
              </label>
              <input
                className="form-control"
                type="file"
                name="file"
                accept="image/*"
                onChange={handleFileChange}
              />

              {error.Image && <ErrorMsg text=" Image is required" />}
              {error.ValidFile && (
                <ErrorMsg text="please upload Image file only" />
              )}
              {error.InValidFileSize && (
                <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file" />
              )}
            </div>
            <div className="col-12 mb-3">
              {FacilityForm.previewUrl && (
                <div className="image-preview">
                  <img
                    src={FacilityForm.previewUrl}
                    alt="Preview"
                    style={{
                      maxWidth: "200px",
                      maxHeight: "200px",
                      marginBottom: "10px",
                    }}
                  />
                </div>
              )}
              {FacilityForm.OldImagePath && FacilityForm.FacilityID > 0 && (
                <div
                  style={{
                    width: "100%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <a
                    href={`${ImageURL}${FacilityForm.OldImagePath}`}
                    target="_blank"
                    style={{
                      textDecoration: "underline",
                      fontSize: "13px",
                    }}
                  >
                    {FacilityForm.OldImagePath.split("/").pop()}
                  </a>
                </div>
              )}
              <input
                type="hidden"
                name="Image"
                id="image-name"
                data-required="true"
                value={FacilityForm.Image || ""}
              />
              <input
                type="hidden"
                name="OldimagePath"
                value={FacilityForm.OldImagePath}
              />
            </div>
          </div>

          <div className="col-md-12" style={{ textAlign: "right" }}>
            <button type="submit" className="butn-dark2">
              <span>Next</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FacilityForm;
